/*
  Custom Sidebar Menu — sidebar-menu.js
  Add to: Assets folder in Shopify theme
  Load via: {{ 'sidebar-menu.js' | asset_url | script_tag }}
*/

(function () {
  'use strict';

  const SELECTORS = {
    sidebar:    '#csmSidebar',
    overlay:    '#csmOverlay',
    closeBtn:   '#csmCloseBtn',
    openBtn:    '[data-csm-open]',        // Add data-csm-open to your hamburger button
    toggleBtn:  '.csm-toggle',
    submenu:    '.csm-submenu',
  };

  const CLASSES = {
    active:    'csm-active',
    open:      'csm-open',
    bodyLock:  'csm-body-lock',
  };

  const sidebar  = document.querySelector(SELECTORS.sidebar);
  const overlay  = document.querySelector(SELECTORS.overlay);
  const closeBtn = document.querySelector(SELECTORS.closeBtn);

  if (!sidebar || !overlay) return; // Safety check

  // ── Open Sidebar ──────────────────────────────────────────────
  function openSidebar() {
    sidebar.classList.add(CLASSES.active);
    overlay.classList.add(CLASSES.active);
    document.body.classList.add(CLASSES.bodyLock);
    sidebar.setAttribute('aria-hidden', 'false');

    // Trap focus: focus close button on open
    setTimeout(() => closeBtn && closeBtn.focus(), 350);
  }

  // ── Close Sidebar ─────────────────────────────────────────────
  function closeSidebar() {
    sidebar.classList.remove(CLASSES.active);
    overlay.classList.remove(CLASSES.active);
    document.body.classList.remove(CLASSES.bodyLock);
    sidebar.setAttribute('aria-hidden', 'true');
  }

  // ── Toggle Submenu ────────────────────────────────────────────
  function toggleSubmenu(toggleBtn) {
    const parentItem = toggleBtn.closest('.csm-item');
    const submenu    = parentItem && parentItem.querySelector(SELECTORS.submenu);
    if (!submenu) return;

    const isOpen = submenu.classList.contains(CLASSES.open);

    // Close all other open submenus (accordion behavior)
    document.querySelectorAll('.csm-submenu.csm-open').forEach(function (el) {
      if (el !== submenu) {
        el.classList.remove(CLASSES.open);
        el.setAttribute('aria-hidden', 'true');
        const siblingToggle = el.closest('.csm-item').querySelector('.csm-toggle');
        if (siblingToggle) {
          siblingToggle.classList.remove(CLASSES.open);
          siblingToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });

    // Toggle current
    submenu.classList.toggle(CLASSES.open, !isOpen);
    submenu.setAttribute('aria-hidden', String(isOpen));
    toggleBtn.classList.toggle(CLASSES.open, !isOpen);
    toggleBtn.setAttribute('aria-expanded', String(!isOpen));
  }

  // ── Event Listeners ───────────────────────────────────────────

  // Open buttons (hamburger) — any element with data-csm-open attribute
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-csm-open]');
    if (trigger) {
      e.preventDefault(); // Stop default link/summary behavior
      e.stopPropagation(); // Stop bubbling to other handlers
      
      // If it's a <summary> inside a <details>, we must close the details manually if open
      const parentDetails = trigger.closest('details');
      if (parentDetails && parentDetails.hasAttribute('open')) {
        parentDetails.removeAttribute('open');
      }
      
      openSidebar();
    }
  });

  // Close button inside sidebar
  if (closeBtn) {
    closeBtn.addEventListener('click', closeSidebar);
  }

  // Overlay click closes sidebar
  overlay.addEventListener('click', closeSidebar);

  // Submenu toggles
  sidebar.addEventListener('click', function (e) {
    const toggle = e.target.closest(SELECTORS.toggleBtn);
    if (toggle) {
      e.preventDefault();
      toggleSubmenu(toggle);
    }
  });

  // ESC key closes sidebar
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sidebar.classList.contains(CLASSES.active)) {
      closeSidebar();
    }
  });

  // ── Expose globally if needed ─────────────────────────────────
  window.csmSidebar = { open: openSidebar, close: closeSidebar };

})();
